import React from 'react';
import { Outlet } from 'react-router';

const MeditationRoomSession = (props) => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default MeditationRoomSession;
